import React from 'react';
import useSEO from '../hooks/useSEO';

export default function Terms() {
  useSEO({
    title: 'Términos y Condiciones | MiEstampita',
    description: 'Términos y condiciones de compra y personalización de estampitas en MiEstampita.',
    path: '/terms',
  });

  return (
    <main className="terms-page">
      <section className="terms-page__content">
        <h1>Términos y Condiciones</h1>
        <p>
          Al utilizar MiEstampita, aceptás estos términos y condiciones. Te invitamos a
          leerlos atentamente antes de realizar una compra.
        </p>
        <h2>Personalización</h2>
        <p>
          Los diseños se personalizan con la información que completás en el formulario. Te
          recomendamos revisar los datos antes de confirmar el pedido.
        </p>
        <h2>Producción y envíos</h2>
        <p>
          Los plazos de producción y envío pueden variar según la demanda y la zona de
          entrega. Te avisaremos cualquier cambio relevante.
        </p>
        <h2>Pagos y reembolsos</h2>
        <p>
          Una vez aprobado el diseño y procesado el pago, comenzamos la producción. Al ser
          un producto personalizado, no se aceptan devoluciones salvo fallas de impresión.
        </p>
        <h2>Contacto</h2>
        <p>
          Ante cualquier consulta, podés escribirnos a{' '}
          <a href="mailto:hola@miestampita.com">hola@miestampita.com</a>.
        </p>
      </section>
    </main>
  );
}
